import { Link } from 'react-router-dom';

interface CardDataStatsProps {
  title: string;
  total: number;
  link?: string;
  color?: string;
  borderColor?: string;
  bgColor?: string;
  state?: any;
  loading?: boolean;
}

const CardDataStats: React.FC<CardDataStatsProps> = ({
  title,
  total,
  link,
  color,
  borderColor,
  bgColor,
  state,
  loading,
}) => {
  return (
    <div
      className={`${bgColor} mb-7.5 rounded-sm border ${borderColor} px-7.5 py-6 shadow-default`}
    >
      <div className='uppercase'>{title}</div>

      {loading ? (
        <>
          <div className='py-2 dark:border-strokedark'>
            <div className='max-w-sm animate-pulse'>
              <div className='h-2 max-w-[220px] rounded-full bg-bodydark'></div>
            </div>
          </div>
        </>
      ) : (
        <h4 className='my-2 text-title-xl font-bold'>{total}</h4>
      )}

      {link && (
        <Link to={link} className={color} state={state}>
          View All
        </Link>
      )}
    </div>
  );
};

export default CardDataStats;
